<template>
  <div class="search-advanced">
    <div class="search-advanced-inner">
      <div class="form-group">
        <div class="input-group d-flex">
          <input type="text" class="form-control" placeholder="ค้นหาจากคำค้น / ตำแหน่งงาน / ชื่อบริษัท">
        </div>
      </div>

      <div class="popular-keyword">
        <strong>คำค้นที่นิยม :</strong>
        <label for="">#Marketing</label>
        <label for="">#ช่างโลหะ</label>
        <label for="">#บัญชี</label>
        <label for="">#วิศวกร</label>
        <label for="">#กรุงเทพมหานคร</label>
        <label for="">#Senior</label>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div class="d-flex">
              <select class="form-control">
                <option selected>สถานที่ปฏิบัติงาน</option>
                <option value="1">กรุงเทพมหานคร</option>
                <option value="2">กระบี่</option>
                <option value="3">ภูเก็ต</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div class="d-flex">
              <select class="form-control">
                <option selected>เงินเดือน</option>
                <option value="1">15000-25000</option>
                <option value="2">2500-35000</option>
                <option value="3">35000-45000</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div class="form-group">
            <div class="d-flex">
              <input type="number" class="form-control" placeholder="ประสบการณ์">
            </div>
          </div>
        </div>
      </div>
      <p class="text-center"><button>ค้นหางาน</button></p>

    </div>
  </div>
</template>

<script>
import IconPlus from '../../icons/Plus.vue'

export default {
  components: { IconPlus },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  &-advanced {
    padding: 3rem 2rem;
    font-size: 22px;
    color: #808184;
    background: #f5f5f5;

    &-inner {
      max-width: 900px;
      margin: 0 auto;
    }
  }
}

.popular-keyword {
  color: #a6a8ab;
  font-size: 1.125rem;

  strong {
    color: #808184;
    font-weight: 600;
  }

  * {
    display: inline-block;
    margin-right: 0.75rem;
  }

  label {
    cursor: pointer;
  }
}

.input-group {
  max-width: 400px;
  margin: 0 auto;
}

.form {
  &-group {
    margin-bottom: 2rem;

    &:not(.no-border) {
      border-bottom: solid 1px #58595b;
    }
  }

  &-control {
    width: 100%;
    height: 60px;
    padding: 10px 0;
    border: none;
    text-align: center;
    background: transparent;
    outline: none;
  }
}

button {
  color: #19499C;
  font-size: 1.375rem;
  border: solid 1px #19499C;
  padding: 0.5rem 2.5rem;
  margin-top: 32px;
  outline: none;
  background: transparent;

  &:hover {
    color: #fff;
    background: #19499C;
  }
}
</style>